<template>
    <div>
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
            <el-tab-pane label="数据概览" name="dataView"></el-tab-pane>
            <el-tab-pane label="商品销售" name="goodsSale"></el-tab-pane>
            <el-tab-pane label="会员数据" name="memberData"></el-tab-pane>
            <el-tab-pane label="资金对账" name="fundReconciliation"></el-tab-pane>
        </el-tabs>
        <router-view class="router-view"></router-view>
    </div>
</template>

<script lang="ts">
import { createComponent, ref } from "@vue/composition-api"
import { routerUtil } from '@/utils/routerUtil'

export default createComponent({
    setup(props, ctx) {
        const {
            activeTabName,
            handleTabClick
        } = routerUtil(ctx)

        return {
            activeTabName,
            handleTabClick
        }
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
    margin-bottom: 12px;
}

.router-view {
    height: calc(100vh - 134px);
}
</style>
